<template>
    <div class="hotel hml_whplt">
        <swiperList :swiperStyle="{padding: '1.44rem .4rem 0'}" :setSwiperNumFlag="true">
            <li
            class="hotelSlide"
            v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
            :key="index"
            @click="hotelSlideClick(index)"
            >
                <img :src="item.thumb">
                <div class="textContent">
                    <h2 class="title">{{ item.title }}</h2>
                    <ul class="keywordsList">
                        <!-- <li>{{ item.keywords }}</li> -->
                        <li
                        v-for="(value,ind) in item.keywords.split('|')"
                        :key="ind"
                        >
                            {{value }}&nbsp;{{ ind == item.keywords.split('|').length - 1?'':'|&nbsp;' }} 
                        </li>
                    </ul>
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    created(){
        // keywords
    },
    mounted(){
        if(this.mapJumpListFlag){
            this.setMapJumpListFlag(false);
            this.hotelSlideClick(this.levelThreeIndex);
        }
        let src = decodeURI(location.search); //获取url中"?"符后的字串
        let theRequest = new Object();
        if (src.indexOf("?") != -1) {
            let str = src.substr(1);
            let strs = str.split("&");
            for(let i = 0; i < strs.length; i ++) {
                theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
            }
        }
        let { firstLevelIndex,levelThreeIndex,secondLevelIndex,url } = theRequest;
        // console.log(this.levelThreeIndex,this.secondLevelIndex,this.urlFlag);
        if((this.levelThreeIndex || this.secondLevelIndex) && !this.urlFlag){
            this.setUrlFlag();
            if(this.levelThreeIndex){
                this.hotelSlideClick(this.levelThreeIndex);
            }
        }
    },
    methods: {
        hotelSlideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.setPlayAroundDetailsFlag(true);
        },
        ...publicData.mapMutations(["setIndex","setPlayAroundDetailsFlag","setMapJumpListFlag","setUrlFlag"])
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex','mapJumpListFlag','urlFlag'])
    }
}
</script>

<style lang="scss" scoped>
.hotel{
    // padding-top: 1.44rem;
    .hotelSlide{
        width: 100%;
        height: 3.76rem;
        border-radius: .1rem;
        margin-bottom: .24rem;
        position: relative;
        overflow: hidden;
        margin-bottom: .24rem;
        box-shadow:0px .13rem .27rem 0px rgba(0, 0, 0, 0.24);
        >img{
            height: 100%;
        }
        .textContent{
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            padding-top: 1rem;
            padding-bottom: .32rem;
            padding-left: .34rem;
            background: linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,.8) 100%);
            .title{
                font-size: .44rem;
                color: #fff;
                font-family: "siyuan";
            }
            .keywordsList{
                display: flex;
                align-items: center;
                margin-top: .2rem;
                li{
                    font-size: .22rem;
                    color: #fff;
                }
            }
        }
    }
}
</style>